import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { LocalStorage } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  constructor(private http: HttpClient, private router: Router,private localStorageService: LocalStorage) { }

  /**
   * Posts request nonce
   * @param walletAddress
   * @returns
   */
  postRequestNonce(walletAddress: any) {
    return this.http.post(`${environment.API_BASE_URL}auth/nonce`, { "walletAddress": walletAddress })
  }

  /**
   * Posts authenticate
   * @param data
   * @returns
   */
  postAuthenticate(data: any) {
    return this.http.post(`${environment.API_BASE_URL}auth/admin/login`, data)
  }

  /**
   * Logs in a sub-admin
   * @param data Login data for the sub-admin
   * @returns An observable containing the response from the server
   */
  subAdminLogin(data: any) {
    return this.http.post(`${environment.API_BASE_URL}auth/sub-admin/login`, data)
  }

  /**
   * Logs out the user and clears their login response and access token from local storage.
   * Navigates the user back to the login page.
   */
  logout() {
    this.localStorageService.clearLocalStorage('accessToken');
    this.localStorageService.clearLocalStorage('loginResponse');
    this.router.navigate(['']);    
  }

}
